<template>
	<div class="padding-box">
		<div class="topinfo">
			<div>
				<div>样品编号:</div>
				{{ dataInfo.proofListVo.sampleNo }}
			</div>
			<div>
				<div>产品编号:</div>
				{{ dataInfo.product.productNo }}
			</div>
			<div>
				<div>看样人:</div>
				{{ dataInfo.user.username }}
			</div>
			<div class="time" v-if="!dataInfo.isTimeoutOne">
				还有<span>{{ dataInfo.twoDay }}</span>天超时
			</div>
			<div class="time" v-else>
				已超时<span>{{ dataInfo.twoDay }}</span>天
			</div>
		</div>
		<div class="change-box">
			<div class="cell" @click="handlePushRouter()">
				<div class="name">打样供应商</div>
				<div class="choose">
					查看所有<i class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
		</div>
		<div class="change-box">
			<div class="cell" @click="
          if (!isFinish) {
				seriesPicker = true;
			} else {
				seriesShowPicker = true;
			}
				">
				<div class="name active">产品系列</div>
				<div class="choose" :class="[
					{ color: seriesName },
					{ error: !seriesName && validate.indexOf('series') != -1 },
				]">
					{{ seriesName ? seriesName : "请选择"
					}}<i class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
		</div>
		<div class="change-box">
			<div class="cell" @click="
          if (!isFinish) {
				decisionPicker = true;
			}
				">
				<div class="name"><span v-if="!isFinish">*</span>看样决策</div>
				<div class="choose" :class="[
					{ color: decisionName },
					{ active: isFinish },
					{ error: !decisionName && validate.indexOf('decision') != -1 },
				]">
					{{ decisionName
					}}<i v-if="!isFinish" class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
			<div class="cell" @click="
          if (!isFinish) {
				remodelPicker = true;
			}
				" v-show="decisionValue == 1">
				<div class="name"><span v-if="!isFinish">*</span>改样负责方</div>
				<div class="choose" :class="[
					{ color: remodelName },
					{ error: !remodelName && validate.indexOf('remodel') != -1 },
					{ active: isFinish },
				]">
					{{ remodelName
					}}<i v-if="!isFinish" class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
			<div class="cell" v-show="decisionValue == 3" @click="
          if (!isFinish) {
				reasonPicker = true;
			}
				">
				<div class="name"><span>*</span>淘汰理由</div>
				<div class="choose" :class="[
					{ color: reasonName },
					{ error: !reasonName && validate.indexOf('reason') != -1 },
					{ active: isFinish },
				]">
					{{ reasonName
					}}<i v-if="!isFinish" class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
			<div class="cell" v-show="decisionValue == 4">
				<div class="name">目标采购价($)</div>
				<div class="choose long active">
					${{ purPriceStart }}-${{ purPriceEnd }}
				</div>
			</div>
			<div class="cell" v-show="decisionValue == 4">
				<div class="name"><span>*</span>建议采购价($)</div>
				<div class="choose long active">
					<van-field v-model="targetPrice" label="" type="number" :disabled="isFinish"
						:error="!targetPrice && validate.indexOf('targetPrice') != -1" placeholder="请输入建议采购价" />
				</div>
			</div>
		</div>
		<div class="change-box" v-if="remodelValue == 3">
			<div class="cell" @click="() => {
				if (!isFinish) {
					selectionOpinionPublisherPicker = true;
				}
			}">
				<div class="name">
					<span v-if="!isFinish">*</span>
					选款意见发表人
				</div>
				<div class="choose" :class="[
					{ color: selectionOpinionPublisherName.length },
					{ error: !selectionOpinionPublisherName.length && validate.indexOf('selectionOpinionPublisher') != -1 },
				]">
					{{ selectionOpinionPublisherName.length ? selectionOpinionPublisherName.join(',') : "请选择"
					}}<i class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
			<div class="cell" @click="
          if (!isFinish) {
				selectionDecisionMakerPicker = true;
			}
				">
				<div class="name">
					<span v-if="!isFinish">*</span>
					选款决策人
				</div>
				<div class="choose" :class="[
					{ color: selectionDecisionMakerName },
					{ error: !selectionDecisionMakerName && validate.indexOf('selectionDecisionMaker') != -1 },
				]">
					{{ selectionDecisionMakerName ? selectionDecisionMakerName : "请选择"
					}}<i class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
			<div class="cell" @click="
          if (!isFinish) {
				styleModifierPicker = true;
			}
				">
				<div class="name">
					<span v-if="!isFinish">*</span>
					款式修改人
				</div>
				<div class="choose" :class="[
					{ color: styleModifierName },
					{ error: !styleModifierName && validate.indexOf('styleModifier') != -1 },
				]">
					{{ styleModifierName ? styleModifierName : "请选择"
					}}
					<i class="iconfont icon-a-xialakaobei"></i>
				</div>
			</div>
		</div>
		<div class="change-box textarea-box order-advice" v-show="decisionValue == 4" :class="{
			error: opinion == '' && validate.indexOf('opinion') != -1,
		}">
			<van-field v-model="opinion" maxlength="300" show-word-limit rows="4" autosize type="textarea"
				:disabled="isFinish" placeholder="请填写下单意见，必填项,最多可填写300个字" />
		</div>
		<div class="change-box textarea-box" v-show="decisionValue == 1" :class="{
			error:
				changeAsk == '<p><br></p>' && validate.indexOf('changeAsk') != -1,
		}">
			<div class="box-height" v-html="changeAsk" v-if="isFinish"></div>
			<template v-else>
				<Editor class="editor" style="height: 150px; overflow-y: hidden" :defaultConfig="editorConfig1"
					v-model="changeAsk" @onCreated="onCreated1" />
			</template>
		</div>
		<div class="change-box textarea-box" v-show="decisionValue == 2" :class="{
			error:
				retention == '<p><br></p>' && validate.indexOf('retention') != -1,
		}">
			<div class="box-height" v-html="retention" v-if="isFinish"></div>
			<template v-else>
				<Editor class="editor" style="height: 150px; overflow-y: hidden" :defaultConfig="editorConfig2"
					v-model="retention" @onCreated="onCreated2" />
			</template>
		</div>
		<div class="change-box textarea-box" v-show="decisionValue == 3" :class="{
			error:
				elimination == '<p><br></p>' && validate.indexOf('elimination') != -1,
		}">
			<div class="box-height" v-html="elimination" v-if="isFinish"></div>
			<template v-else>
				<Editor class="editor" style="height: 150px; overflow-y: hidden" :defaultConfig="editorConfig3"
					v-model="elimination" @onCreated="onCreated3" />
			</template>
		</div>
		<decision-form ref="form" v-show="decisionValue == 4" :orderList="orderList" :colorList="colorList"
			:prfTLookDecide="isFinish"></decision-form>
		<div class="fontBut" v-if="!isFinish">
			<div class="but" @click="addOrder">
				添加材质
			</div>
			<div class="but" @click="backTo">上一步</div>
			<!-- 提交决策 -->
			<div class="but solid-but" @click="confirm(2)">
				提交
			</div>
			<div class="but solid-but" @click="confirm(1)">保存</div>
		</div>
		<div class="fontBut" v-else>
			<div class="but" @click="backTo">查看样品图标记</div>
		</div>
		<van-popup v-model="seriesPicker" round position="center">
			<div class="series-box">
				<div class="series-list">
					<van-checkbox-group v-model="firstChecked" @change="changeSeries">
						<div class="title">产品线</div>
						<div class="list-box">
							<div class="series-cell" v-for="(series, index) in seriesList" :key="series.serialId"
								:class="{ active: seriesIndex == index }" @click="selectSeries(index)">
								<div>{{ series.serialName }}</div>
								<van-checkbox :name="series.serialId" />
							</div>
						</div>
					</van-checkbox-group>
				</div>
				<div class="series-list">
					<van-checkbox-group v-model="secondChecked" @change="changeType">
						<div class="title">系列</div>
						<div class="list-box">
							<div class="series-cell" v-for="(series, index) in typeList" :key="series.serialId"
								:class="{ active: typeIndex == index }" @click="selectType(index)">
								<div>{{ series.serialName }}</div>
								<van-checkbox :name="series.serialId" />
							</div>
						</div>
					</van-checkbox-group>
				</div>
				<div class="series-list">
					<van-checkbox-group v-model="thirdChecked" @change="changeName">
						<div class="title">品名</div>
						<div class="list-box">
							<div class="series-cell" v-for="series in nameList" :key="series.serialId"
								@click="selectName">
								<div>{{ series.serialName }}</div>
								<van-checkbox :name="series.serialId" />
							</div>
						</div>
					</van-checkbox-group>
				</div>
			</div>
			<div class="seriesError">
				{{ seriesError ? "至少要保留一个产品系列" : "" }}
			</div>
			<div class="but-group">
				<div class="but" @click="seriesPicker = false">取消</div>
				<div class="but" @click="saveSeries">保存</div>
			</div>
		</van-popup>

		<van-popup v-model="seriesShowPicker" round position="center">
			<div class="showSeries-box">
				<div class="show-title">产品系列</div>
				<div class="show-list">
					<div class="list" v-for="(series, index) in showSeriesList" :key="index">
						{{ series }}
					</div>
				</div>
				<div class="but-group">
					<div class="but" @click="seriesShowPicker = false">取消</div>
				</div>
			</div>
		</van-popup>
		<van-popup v-model="remodelPicker" round position="bottom">
			<van-picker :title="'改样负责方'" show-toolbar v-model="remodelValue" :columns="remodelList"
				@cancel="remodelPicker = false" @confirm="remodelConfirm" />
		</van-popup>
		<van-popup v-model="decisionPicker" round position="bottom">
			<van-picker :title="'看样决策'" show-toolbar v-model="decisionValue" :columns="decisionList"
				@cancel="decisionPicker = false" @confirm="decisionConfirm" />
		</van-popup>
		<van-popup v-model="reasonPicker" round position="bottom">
			<van-picker :title="'淘汰理由'" show-toolbar v-model="reasonValue" :columns="reasonList"
				@cancel="reasonPicker = false" @confirm="reasonConfirm" value-key="dictLabel" />
		</van-popup>
		<van-popup v-model="colorPicker" round position="bottom">
			<van-picker :title="'颜色要求'" show-toolbar v-model="colorValue" :columns="colorList"
				@cancel="colorPicker = false" @confirm="colorConfirm" value-key="dictLabel" />
		</van-popup>
		<van-popup v-model="selectionDecisionMakerPicker" round position="bottom">
			<van-picker :title="'选款决策人'" show-toolbar v-model="selectionDecisionMakerValue"
				:columns="selectionDecisionMakerList" @cancel="selectionDecisionMakerPicker = false"
				@confirm="selectionDecisionMakerConfirm" />
		</van-popup>
		<van-popup v-model="styleModifierPicker" round position="bottom">
			<van-picker :title="'款式修改人'" show-toolbar v-model="styleModifierValue" :columns="styleModifierList"
				@cancel="styleModifierPicker = false" @confirm="styleModifierConfirm" />
		</van-popup>
		<van-popup v-model="selectionOpinionPublisherPicker" round position="bottom">
			<div class="popup-container">
				<div class="van-picker__toolbar">
					<button class="van-picker__cancel" @click="selectionOpinionPublisherPicker = false">取消</button>
					<span class="van-ellipsis van-picker__title">选款意见发表人</span>
					<button class="van-picker__confirm" @click="() => {
						selectionOpinionPublisherPicker = false
						this.selectionOpinionPublisherValue = this.cSelectionOpinionPublisherValue;
						this.selectionOpinionPublisherName = this.cSelectionOpinionPublisherName;
					}">确认</button>
				</div>
				<div class="van-picker__columns publisher-list" style="height: 264px;">
					<div class="van-picker-column">
						<div class="column-item" @click="handleSelectionOpinionPublisher(item)"
							:class="{ select: cSelectionOpinionPublisherValue.indexOf(item.value) >= 0 }"
							v-for="(item, key) in selectionOpinionPublisherList" :key="key">
							<span class="text">{{ item.text }}</span>
							<span class="van-icon van-icon-success"></span>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { Dialog } from 'vant';
import wx from "weixin-js-sdk";
import { sampleApi } from "../api/lookApi/api";
import DecisionForm from "./DecisionForm.vue";
import { Editor } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";
import { getDecisionChoosenApi, getChangeProChoosenApi, getAdviceChoosenApi } from './../api/decision';

const pageApi = new sampleApi();

export default {
	name: "uiDecisionOpinion",
	components: { Editor, DecisionForm },
	data() {
		return {
			showSeriesList: [],
			addColorList: [],
			changeAsk: "",
			elimination: "",
			retention: "",
			validate: [],
			decisionPicker: false,
			opinion: "",
			decisionList: [
				{ text: "改样", value: 1 },
				{ text: "留样", value: 2 },
				{ text: "淘汰", value: 3 },
				{ text: "下单", value: 4 },
			],
			decisionName: "改样",
			decisionValue: 1,
			remodelPicker: false,
			remodelList: [
				{ text: "自行改样", value: "1" },
				{ text: "重新打样", value: "2" },
				{ text: "设计部改样", value: "3" },
			],
			remodelName: "自行改样",
			remodelValue: "1",
			seriesPicker: false,
			seriesList: [],
			typeList: [],
			seriesValue: "",
			reasonPicker: false,
			reasonList: [],
			reasonName: "",
			reasonValue: "",
			colorPicker: false,
			colorList: [],
			colorName: "",
			colorValue: "",
			targetPrice: "",
			orderAmount: "",
			remark: "",
			prfTLookDecide: false,
			firstChecked: [],
			copyfirstChecked: [],
			secondChecked: [],
			copysecondChecked: [],
			thirdChecked: [],
			copythirdChecked: [],
			nameList: [],
			seriesIndex: 0,
			typeIndex: 0,
			lock: false,
			seriesLock: false,
			nameLock: false,
			seriesNameList: [],
			seriesName: "",
			seriesError: false,
			temporary: "",
			colorIndex: 0,
			seriesShowPicker: false,
			editorConfig1: {
				placeholder: "(必填）请输入改样要求，最多500个字……",
				maxLength: 500,
				// autoFocus: false,

				// 所有的菜单配置，都要在 MENU_CONF 属性下
				MENU_CONF: {
					uploadImage: {
						fieldName: "your-fileName",
						base64LimitSize: 10 * 1024 * 1024, // 10M 以下插入 base64
					},
				},
			},
			editorConfig2: {
				placeholder: "(必填）请输入留样理由，最多500个字……",
				maxLength: 500,
				// autoFocus: false,

				// 所有的菜单配置，都要在 MENU_CONF 属性下
				MENU_CONF: {
					uploadImage: {
						fieldName: "your-fileName",
						base64LimitSize: 10 * 1024 * 1024, // 10M 以下插入 base64
					},
				},
			},
			editorConfig3: {
				placeholder: "(必填）请输入淘汰理由，最多500个字……",
				maxLength: 500,
				// autoFocus: false,

				// 所有的菜单配置，都要在 MENU_CONF 属性下
				MENU_CONF: {
					uploadImage: {
						fieldName: "your-fileName",
						base64LimitSize: 10 * 1024 * 1024, // 10M 以下插入 base64
					},
				},
			},
			editor1: null,
			editor2: null,
			editor3: null,
			colorObj: {},
			purPriceEnd: 0,
			purPriceStart: 0,
			salesmanList: [],
			loading: false,
			selectionDecisionMakerPicker: false,
			selectionDecisionMakerValue: null,
			selectionDecisionMakerName: '',
			selectionDecisionMakerList: [],
			styleModifierPicker: false,
			styleModifierValue: null,
			styleModifierName: '',
			styleModifierList: [],
			selectionOpinionPublisherPicker: false,
			selectionOpinionPublisherValue: [],
			cSelectionOpinionPublisherValue: [],
			selectionOpinionPublisherName: [],
			cSelectionOpinionPublisherName: [],
			selectionOpinionPublisherList: [],

		};
	},
	inject: ["reload"],
	props: {
		dataInfo: {
			addition: {},
			orderList: [],
			proofListVo: {},
			prfTLookDecide: {},
			prfTLookLog: {},
			prfTLookMain: {},
			product: {},
			user: {},
			start: {},
			xdVo: {
				america: "",
			},
			isAllComplete: null
		},
		orderList: {
			default: () => {
				return [];
			},
		},
		nextpointerList: [],
	},
	computed: {
		isFinish() {
			if (
				this.dataInfo.prfTLookDecide &&
				this.dataInfo.prfTLookDecide.temporary == 2
			) {
				return true;
			} else {
				return false;
			}
		},
	},
	watch: {
		dataInfo: {
			handler() {
				this.init();
			},
		},
	},
	methods: {
		async getUserList() {
			const info = {
				proofId: this.$route.query.proofId,
				userType: 2,
			};
			const list = await pageApi.getSalesmanList(info);
			/* 如果当前登录用户也在看样意见人里面，则将其移到数组第一个 */
			this.salesmanList = JSON.parse(JSON.stringify(list));
		},
		onCreated1(editor) {
			// const that = this
			this.editor1 = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
			this.$nextTick(() => {
				const editor = this.editor1;
				editor.setHtml(this.changeAsk);
			});
		},
		onCreated2(editor) {
			// const that = this
			this.editor2 = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
			this.$nextTick(() => {
				const editor = this.editor2;
				editor.setHtml(this.retention);
			});
		},
		onCreated3(editor) {
			// const that = this
			this.editor3 = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
			this.$nextTick(() => {
				const editor = this.editor3;
				editor.setHtml(this.elimination);
			});
		},
		// 添加颜色
		addColor() {
			this.addColorList.unshift(JSON.parse(JSON.stringify(this.colorObj)));
		},
		addOrder() {
			scrollTo({ top: 200, behavior: "smooth" });
			this.$refs.form.addColor();
		},
		// 计算总件数
		sum(arr) {
			let num = 0;
			arr.forEach((item) => {
				if (item) {
					num = num + parseInt(item);
				}
			});
			return num;
		},
		// 保存系列
		saveSeries() {
			if (this.seriesNameList.length > 0) {
				this.seriesName = this.seriesNameList.join(",");
				this.remark = this.thirdChecked.join(",");
				this.seriesPicker = false;
			} else {
				this.seriesError = true;
			}
		},
		backTo() {
			this.$emit("backTo");
		},
		/* 获取产品系列 */
		async getSeriesList() {
			let res = await pageApi.getList();
			if (res.success) {
				this.seriesList = res.data.proTypeList;
				this.typeList = this.seriesList[0].children;
				this.nameList = this.seriesList[0].children[0].children;
				this.seriesList.forEach((item) => {
					this.deepSeries(item);
				});
				this.copysecondChecked = this.secondChecked;
				this.seriesList.forEach((item) => {
					this.deepSecondChecked(item);
				});
				this.copyfirstChecked = this.firstChecked;
			}
		},
		deepSeries(parent) {
			if (parent.children) {
				let num = 0;
				parent.children.forEach((item) => {
					if (this.thirdChecked.indexOf(item.serialId) != -1) {
						num++;
					}
					if (num == parent.children.length) {
						this.secondChecked.push(parent.serialId);
					}
					this.deepSeries(item);
				});
			}
		},
		deepSecondChecked(parent) {
			if (parent.children) {
				let num = 0;
				parent.children.forEach((item) => {
					if (this.secondChecked.indexOf(item.serialId) != -1) {
						num++;
					}
					if (num == parent.children.length) {
						this.firstChecked.push(parent.serialId);
					}
				});
			}
		},
		// 改变产品线
		changeSeries(e) {
			if (this.seriesLock) {
				return false;
			}

			const arr1 = this.firstChecked;
			const arr2 = this.copyfirstChecked;
			if (arr1.length > arr2.length) {
				const arr = arr1
					.concat(arr2)
					.filter((e) => arr1.includes(e) && !arr2.includes(e));
				this.seriesList[this.seriesIndex].children.forEach((item, index) => {
					if (this.secondChecked.indexOf(item.serialId) == -1) {
						this.secondChecked.push(item.serialId);
						this.typeChoose(1, this.seriesIndex, index);
					}
				});
			} else {
				const arr = arr2
					.concat(arr1)
					.filter((e) => arr2.includes(e) && !arr1.includes(e));
				this.seriesList[this.seriesIndex].children.forEach((item, index) => {
					if (this.secondChecked.indexOf(item.serialId) != -1) {
						this.secondChecked.splice(
							this.secondChecked.indexOf(item.serialId),
							1
						);
						this.typeChoose(2, this.seriesIndex, index);
					}
				});
			}
			this.copysecondChecked = this.secondChecked;
			this.copyfirstChecked = this.firstChecked;
		},
		// 选择产品线
		selectSeries(index) {
			this.seriesIndex = index;
			this.seriesLock = false;
			this.nameLock = true;
			this.lock = true;
			this.typeIndex = 0;
			this.typeList = this.seriesList[index].children;
			this.nameList = this.seriesList[index].children[0].children;
		},
		// 改变系列
		changeType(e) {
			if (this.lock) {
				return false;
			}
			const arr1 = this.secondChecked;
			const arr2 = this.copysecondChecked;
			if (arr1.length > arr2.length) {
				const arr = arr1
					.concat(arr2)
					.filter((e) => arr1.includes(e) && !arr2.includes(e));
				this.typeChoose(1, this.seriesIndex, this.typeIndex);
			} else {
				const arr = arr2
					.concat(arr1)
					.filter((e) => arr2.includes(e) && !arr1.includes(e));
				this.typeChoose(2, this.seriesIndex, this.typeIndex);
			}
			this.copysecondChecked = this.secondChecked;
			let num = 0;
			this.seriesList[this.seriesIndex].children.forEach((item) => {
				if (this.secondChecked.indexOf(item.serialId) != -1) {
					num++;
				}
			});
			if (this.seriesList[this.seriesIndex].children.length == num) {
				this.firstChecked.push(this.seriesList[this.seriesIndex].serialId);
			} else {
				if (
					this.firstChecked.indexOf(
						this.seriesList[this.seriesIndex].serialId
					) != -1
				) {
					this.firstChecked.splice(
						this.firstChecked.indexOf(
							this.seriesList[this.seriesIndex].serialId
						),
						1
					);
				}
			}
			this.copyfirstChecked = this.firstChecked;
		},
		typeChoose(type, index, childindex) {
			if (type == 1) {
				this.seriesList[index].children[childindex].children.forEach(
					(item, itemindex) => {
						if (this.thirdChecked.indexOf(item.serialId) == -1) {
							this.thirdChecked.push(item.serialId);
							this.setName(1, index, childindex, itemindex);
						}
					}
				);
			} else {
				this.seriesList[index].children[childindex].children.forEach(
					(item, itemindex) => {
						if (this.thirdChecked.indexOf(item.serialId) != -1) {
							this.thirdChecked.splice(
								this.thirdChecked.indexOf(item.serialId),
								1
							);
							this.setName(2, index, childindex, itemindex);
						}
					}
				);
			}
		},
		// 选择系列
		selectType(index) {
			this.lock = false;
			this.nameLock = true;
			this.seriesLock = true;
			this.typeIndex = index;
			this.nameList =
				this.seriesList[this.seriesIndex].children[index].children;
		},
		// 改变品名
		changeName() {
			if (this.nameLock) {
				return false;
			}

			const arr1 = this.thirdChecked;
			const arr2 = this.copythirdChecked;
			if (arr1.length > arr2.length) {
				const arr = arr1
					.concat(arr2)
					.filter((e) => arr1.includes(e) && !arr2.includes(e));

				this.seriesList[this.seriesIndex].children[
					this.typeIndex
				].children.forEach((item, itemindex) => {
					if (item.serialId == arr[0]) {
						this.setName(1, this.seriesIndex, this.typeIndex, itemindex);
					}
				});
			} else {
				const arr = arr2
					.concat(arr1)
					.filter((e) => arr2.includes(e) && !arr1.includes(e));
				this.seriesList[this.seriesIndex].children[
					this.typeIndex
				].children.forEach((item, itemindex) => {
					if (item.serialId == arr[0]) {
						this.setName(2, this.seriesIndex, this.typeIndex, itemindex);
					}
				});
			}
			this.copythirdChecked = this.thirdChecked;

			let num = 0;
			this.seriesList[this.seriesIndex].children[
				this.typeIndex
			].children.forEach((item) => {
				if (this.thirdChecked.indexOf(item.serialId) != -1) {
					num++;
				}
			});
			if (
				num ==
				this.seriesList[this.seriesIndex].children[this.typeIndex].children
					.length
			) {
				this.secondChecked.push(
					this.seriesList[this.seriesIndex].children[this.typeIndex].serialId
				);
				let firstnum = 0;
				this.seriesList[this.seriesIndex].children.forEach((item) => {
					if (this.secondChecked.indexOf(item.serialId) != -1) {
						firstnum++;
					}
				});
				if (this.seriesList[this.seriesIndex].children.length == firstnum) {
					this.firstChecked.push(this.seriesList[this.seriesIndex].serialId);
				}
			} else {
				if (
					this.firstChecked.indexOf(
						this.seriesList[this.seriesIndex].serialId
					) != -1
				) {
					this.firstChecked.splice(
						this.firstChecked.indexOf(
							this.seriesList[this.seriesIndex].serialId
						),
						1
					);
				}
				if (
					this.secondChecked.indexOf(
						this.seriesList[this.seriesIndex].children[this.typeIndex].serialId
					) != -1
				) {
					this.secondChecked.splice(
						this.secondChecked.indexOf(
							this.seriesList[this.seriesIndex].children[this.typeIndex]
								.serialId
						),
						1
					);
				}
			}
			this.copyfirstChecked = this.firstChecked;
			this.copysecondChecked = this.secondChecked;
		},
		// 点击品名
		selectName() {
			this.lock = true;
			this.nameLock = false;
			this.seriesLock = true;
		},
		// 赋予系列名字
		setName(type, index, childindex, itemindex) {
			let firstName = this.seriesList[index].serialName;
			let secondName = this.seriesList[index].children[childindex].serialName;
			let thirdName =
				this.seriesList[index].children[childindex].children[itemindex]
					.serialName;
			let name = firstName + " - " + secondName + " - " + thirdName;
			if (type == 1) {
				this.seriesNameList.push(name);
			} else {
				this.seriesNameList.splice(this.seriesNameList.indexOf(name), 1);
			}
			if (this.seriesNameList.length > 0) {
				this.seriesError = false;
			} else {
				this.seriesError = true;
			}
		},

		// 确认决策
		decisionConfirm(event) {
			if (event.value === 4) {
				if (this.dataInfo.isAllComplete === 0) {
					Dialog.confirm({
						title: '提示',
						message: `等待产品信息完善后方可下单`,
						showConfirmButton: false,
						cancelButtonText: '关闭'
					}).then(() => { })
					return;
				}

				if (this.dataInfo.placeOrder) {
					Dialog.confirm({
						title: '提示',
						message: `已下单样品编号\n${this.dataInfo.placeOrderNo}`,
						showConfirmButton: false,
						cancelButtonText: '关闭'
					}).then(() => { })
					return;
				}

			}
			this.decisionName = event.text;
			this.decisionValue = event.value;
			this.decisionPicker = false;
		},
		// 获取颜色
		async getLookProofColors() {
			this.colorList = await pageApi.getLookProofColors();
		},
		// 确认颜色
		colorConfirm(event) {
			this.addColorList[this.colorIndex].colorName = event.dictLabel;
			this.addColorList[this.colorIndex].colorType = event.dictValue;
			this.colorPicker = false;
		},
		// 删除颜色
		deleColor(index) {
			this.$dialog
				.confirm({
					title: "提示",
					message: "是否确认删除",
					confirmButtonColor: "#3F996C",
				})
				.then(async (action) => {
					this.addColorList.splice(index, 1);
				});
		},
		// 获取淘汰理由
		async getDecideOutReason() {
			this.reasonList = await pageApi.getDecideOutReason();
			this.reasonName = this.reasonList[0].dictLabel;
			this.reasonValue = this.reasonList[0].dictValue;
		},

		// 确认负责方
		remodelConfirm(event) {
			if (event.value == 3) {
				if (this.dataInfo.placeDesign) {
					Dialog.confirm({
						title: '提示',
						message: `已设计部改样样品编号\n${this.dataInfo.placeDesignNo}`,
						showConfirmButton: false,
						cancelButtonText: '关闭'
					}).then(() => { })
					return;
				}
			}
			this.remodelName = event.text;
			this.remodelValue = event.value;
			this.remodelPicker = false;
		},
		// 确认淘汰理由
		reasonConfirm(event) {
			this.reasonName = event.dictLabel;
			this.reasonValue = event.dictValue;
			this.reasonPicker = false;
		},

		// 验证表单
		validateForm() {
			this.validate = [];
			console.log(this.decisionValue);
			if (this.decisionValue == 1) {

				console.log(this.remodelValue);
				if (this.remodelValue == 3) {
					if (this.selectionOpinionPublisherValue.length === 0) {
						if (this.validate.indexOf("selectionOpinionPublisher") == -1) {
							this.validate.push("selectionOpinionPublisher");
						}
					} else {
						if (this.validate.indexOf("selectionOpinionPublisher") != -1) {
							this.validate.splice(this.validate.indexOf("selectionOpinionPublisher"), 1);
						}
					}

					if (!this.selectionDecisionMakerValue) {
						if (this.validate.indexOf("selectionDecisionMaker") == -1) {
							this.validate.push("selectionDecisionMaker");
						}
					} else {
						if (this.validate.indexOf("selectionDecisionMaker") != -1) {
							this.validate.splice(this.validate.indexOf("selectionDecisionMaker"), 1);
						}
					}

					if (!this.styleModifierValue) {
						if (this.validate.indexOf("styleModifier") == -1) {
							this.validate.push("styleModifier");
						}
					} else {
						if (this.validate.indexOf("styleModifier") != -1) {
							this.validate.splice(this.validate.indexOf("styleModifier"), 1);
						}
					}
				}

				if (this.changeAsk == "<p><br></p>") {
					if (this.validate.indexOf("changeAsk") == -1) {
						this.validate.push("changeAsk");
					}
				} else {
					if (this.validate.indexOf("changeAsk") != -1) {
						this.validate.splice(this.validate.indexOf("changeAsk"), 1);
					}
				}
			}

			if (this.decisionValue == 2) {
				if (this.retention == "<p><br></p>") {
					if (this.validate.indexOf("retention") == -1) {
						this.validate.push("retention");
					}
				} else {
					if (this.validate.indexOf("retention") != -1) {
						this.validate.splice(this.validate.indexOf("retention"), 1);
					}
				}
			}

			if (this.decisionValue == 3) {
				if (this.elimination == "<p><br></p>") {
					if (this.validate.indexOf("elimination") == -1) {
						this.validate.push("elimination");
					}
				} else {
					if (this.validate.indexOf("elimination") != -1) {
						this.validate.splice(this.validate.indexOf("elimination"), 1);
					}
				}
			}
			let isError = false;
			if (this.decisionValue == 4) {
				if (this.targetPrice == "") {
					if (this.validate.indexOf("targetPrice") == -1) {
						this.validate.push("targetPrice");
					}
				} else {
					if (this.validate.indexOf("targetPrice") != -1) {
						this.validate.splice(this.validate.indexOf("targetPrice"), 1);
					}
				}
				if (this.opinion == "") {
					if (this.validate.indexOf("opinion") == -1) {
						this.validate.push("opinion");
					}
				} else {
					if (this.validate.indexOf("opinion") != -1) {
						this.validate.splice(this.validate.indexOf("opinion"), 1);
					}
				}
				isError = this.$refs.form.checkValid();
			}

			if (this.validate.length > 0 || isError) {
				return false;
			} else {
				return true;
			}
		},
		// 提交决策
		confirm(temporary) {
			this.temporary = temporary;
			console.log(this.dataInfo.isAllComplete, 'dataInfo');

			if (this.validateForm()) {
				if (this.temporary == 2) {
					var message = "是否确认提交？";
				} else {
					var message = "是否确认保存？";
				}

				if (this.loading) {
					return;
				}
				this.$dialog.confirm({
					title: "提示",
					message: message,
					confirmButtonColor: "#3F996C",
				}).then(async (action) => {
					this.loading = true;

					let pointer = JSON.parse(JSON.stringify(this.nextpointerList));
					pointer = pointer.filter((item) => {
						return item.userId == this.$route.query.userId;
					});
					pointer = pointer.filter((item) => {
						return item.type != 1;
					});
					let info = {
						temporary: this.temporary,
						pointList: pointer,
						proofId: this.$route.query.proofId,
						userId: this.salesmanList[0] ? this.salesmanList[0].userId : "",
						status: this.decisionValue,
						remark: this.remark,
						orderList: [],
						reviseType: "",
						reviseText: "",
						outType: "",
						price: "",
						mobileUserId: this.salesmanList[0]
							? this.salesmanList[0].userId
							: "",
					};
					if (this.decisionValue == 1) {
						info.reviseType = this.remodelValue;
						info.reviseText = this.changeAsk;

						if (this.remodelValue == 3) {
							info.adviceUsers = [];

							for (let i = 0; i < this.selectionOpinionPublisherList.length; i++) {
								for (let j = 0; j < this.selectionOpinionPublisherValue.length; j++) {
									if (this.selectionOpinionPublisherValue[j] === this.selectionOpinionPublisherList[i].value) {
										info.adviceUsers.push({
											name: this.selectionOpinionPublisherList[i].text,
											userId: this.selectionOpinionPublisherList[i].value,
										})
									}
								}
							}

							// info.adviceUsers = [];

							info.changeUser = {
								userId: this.styleModifierValue,
								name: this.styleModifierName,
							};

							info.decisionUser = {
								userId: this.selectionDecisionMakerValue,
								name: this.selectionDecisionMakerName,
							};
						}
					}
					if (this.decisionValue == 2) {
						info.reviseText = this.retention;
					}

					if (this.decisionValue == 3) {
						info.reviseText = this.elimination;
						info.outType = this.reasonValue;
					}

					if (this.decisionValue == 4) {
						let orderList = JSON.parse(
							JSON.stringify(this.$refs.form.formList)
						);
						orderList.forEach((order) => {
							order.orderList.forEach((item) => {
								item.allList.forEach((ct) => {
									ct.codes.forEach((code) => {
										code.market = ct.market;
									});
								});
								item.asianList.forEach((ct) => {
									ct.codes.forEach((code) => {
										code.market = ct.market;
									});
								});
								item.europeList.forEach((ct) => {
									ct.codes.forEach((code) => {
										code.market = ct.market;
									});
								});
							})
						});
						info.orderList = orderList;
						info.price = this.targetPrice;
						info.opinion = this.opinion;
					}
					let res = await pageApi.decideSubmit(info);
					if (res.success) {
						this.loading = false;
						wx.miniProgram.navigateBack();
						this.$notify({
							message: res.message,
							type: "success",
							duration: 5000,
						});
					} else {
						this.loading = false;
						this.$notify({
							message: res.message,
							type: "danger",
							duration: 5000,
						});
					}
				}).catch(() => {
				});
			}
		},
		// 初始化
		init() {
			this.purPriceEnd = this.dataInfo.purPriceEnd;
			this.purPriceStart = this.dataInfo.purPriceStart;

			let prfTLookDecide = this.dataInfo.prfTLookDecide;
			this.prfTLookDecide = this.dataInfo.prfTLookDecide.temporary
				? true
				: false;

			let series = prfTLookDecide.remark
				? prfTLookDecide.remark
				: this.dataInfo.product.descType;
			this.remark = series;
			let descType = series.split(",").map((item) => {
				return item * 1;
			});
			this.thirdChecked = descType;
			this.copythirdChecked = descType;
			this.seriesNameList = prfTLookDecide.descType
				? prfTLookDecide.descType
				: this.dataInfo.descType;
			this.showSeriesList = prfTLookDecide.descType
				? prfTLookDecide.descType
				: [];
			this.seriesName = this.seriesNameList.join(",");

			this.targetPrice = this.dataInfo.fob ? this.dataInfo.fob : "";
			if (!prfTLookDecide.status) {
				this.addColorList.unshift(JSON.parse(JSON.stringify(this.colorObj)));
				return false;
			}
			this.decisionValue = prfTLookDecide.status;
			this.decisionList.forEach((item) => {
				if (item.value == prfTLookDecide.status) {
					this.decisionName = item.text;
				}
			});
			this.opinion = this.dataInfo.prfTLookDecide.opinion;
			if (this.decisionValue == 1) {
				this.remodelValue = prfTLookDecide.reviseType;
				this.changeAsk = prfTLookDecide.reviseText;
				this.remodelList.forEach((item) => {
					if (item.value == prfTLookDecide.reviseType) {
						this.remodelName = item.text;
					}
				});
			}
			if (this.decisionValue == 2) {
				this.retention = prfTLookDecide.reviseText;
			}
			if (this.decisionValue == 3) {
				this.reasonValue = prfTLookDecide.outType;
				this.reasonList.forEach((item) => {
					if (item.dictValue == prfTLookDecide.outType) {
						this.reasonName = item.dictLabel;
					}
				});

				this.elimination = prfTLookDecide.reviseText;
			}
			if (this.decisionValue == 4) {
				if (prfTLookDecide) {
					this.addColorList = this.dataInfo.orderList;
					this.addColorList.forEach((item) => {
						this.colorList.forEach((coloritem) => {
							if (coloritem.dictValue == item.colorType) {
								item.colorName = coloritem.dictLabel;
							}
						});
					});
					this.targetPrice = prfTLookDecide.price;
				} else {
					this.addColorList.unshift(JSON.parse(JSON.stringify(this.colorObj)));
					this.addColorList.forEach((item) => {
						this.colorList.forEach((coloritem) => {
							if (coloritem.dictValue == item.colorType) {
								item.colorName = coloritem.dictLabel;
							}
						});
					});
				}
			} else {
				this.addColorList.unshift(JSON.parse(JSON.stringify(this.colorObj)));
			}
		},
		handlePushRouter() {
			this.$router.push(
				`/SampleSupplier?proofId=${this.$route.query.proofId}&userId=${this.$route.query.userId}`
			);
		},
		selectionDecisionMakerConfirm(event) {
			this.selectionDecisionMakerName = event.text;
			this.selectionDecisionMakerValue = event.value;
			this.selectionDecisionMakerPicker = false;
		},
		async getDecisionChoosenList() {
			const response = await getDecisionChoosenApi();
			if (response.success) {
				let list = []
				for (let i = 0; i < response.data.decisionPeople.length; i++) {
					if (response.data.decisionPeople[i].users) {
						list.push(...response.data.decisionPeople[i].users);
					}
					if (response.data.decisionPeople[i].children) {
						for (let j = 0; j < response.data.decisionPeople[i].children.length; j++) {
							if (response.data.decisionPeople[i].children[j].users) {
								list.push(...response.data.decisionPeople[i].children[j].users);
							}

							if (response.data.decisionPeople[i].children[j].children) {
								for (let k = 0; k < response.data.decisionPeople[i].children[j].length; k++) {
									if (response.data.decisionPeople[i].children[j].children[j].users) {
										list.push(...response.data.decisionPeople[i].children[j].children[k].users);
									}
								}
							}
						}
					}
				}
				this.selectionDecisionMakerList = []
				list.forEach((item) => {
					this.selectionDecisionMakerList.push({
						text: item.name,
						value: item.userId,
					})
				});
			}
		},
		styleModifierConfirm(event) {
			this.styleModifierName = event.text;
			this.styleModifierValue = event.value;
			this.styleModifierPicker = false;
		},
		async getChangeProChoosenList() {
			const response = await getChangeProChoosenApi();
			if (response.success) {
				let list = [];

				for (let i = 0; i < response.data.changePeople.length; i++) {
					if (response.data.changePeople[i].users) {
						list.push(...response.data.changePeople[i].users);
					}
					if (response.data.changePeople[i].children) {
						for (let j = 0; j < response.data.changePeople[i].children.length; j++) {
							if (response.data.changePeople[i].children[j].users) {
								list.push(...response.data.changePeople[i].children[j].users);
							}

							if (response.data.changePeople[i].children[j].children) {
								for (let k = 0; k < response.data.changePeople[i].children[j].length; k++) {
									if (response.data.changePeople[i].children[j].children[j].users) {
										list.push(...response.data.changePeople[i].children[j].children[k].users);
									}
								}
							}
						}
					}
				}
				this.styleModifierList = []
				list.forEach((item) => {
					this.styleModifierList.push({
						text: item.name,
						value: item.userId,
					})
				});
			}
		},
		async getAdviceChoosenList() {
			const response = await getAdviceChoosenApi();
			if (response.success) {
				let list = [];

				for (let i = 0; i < response.data.advicePeople.length; i++) {
					if (response.data.advicePeople[i].users) {
						list.push(...response.data.advicePeople[i].users);
					}
					if (response.data.advicePeople[i].children) {
						for (let j = 0; j < response.data.advicePeople[i].children.length; j++) {
							if (response.data.advicePeople[i].children[j].users) {
								list.push(...response.data.advicePeople[i].children[j].users);
							}

							if (response.data.advicePeople[i].children[j].children) {
								for (let k = 0; k < response.data.advicePeople[i].children[j].length; k++) {
									if (response.data.advicePeople[i].children[j].children[j].users) {
										list.push(...response.data.advicePeople[i].children[j].children[k].users);
									}
								}
							}
						}
					}
				}
				this.selectionOpinionPublisherList = []
				list.forEach((item) => {
					this.selectionOpinionPublisherList.push({
						text: item.name,
						value: item.userId,
					})
				});
				console.log(this.selectionOpinionPublisherList);
			}
		},
		handleSelectionOpinionPublisher(item) {
			if (this.cSelectionOpinionPublisherValue.indexOf(item.value) >= 0) {
				let index = this.cSelectionOpinionPublisherValue.indexOf(item.value);
				this.cSelectionOpinionPublisherValue.splice(index, 1);
				this.cSelectionOpinionPublisherName.splice(index, 1);
			} else {
				this.cSelectionOpinionPublisherValue.push(item.value);
				this.cSelectionOpinionPublisherName.push(item.text);
			}
		}
	},
	async mounted() {
		await this.getUserList();
		await this.getLookProofColors();
		await this.getDecideOutReason();
		this.getSeriesList();
		this.getDecisionChoosenList();
		this.getChangeProChoosenList();
		this.getAdviceChoosenList()
	},
};
</script>

<style lang="scss" scoped>
::v-deep .van-field__control:disabled {
	color: #303133;
	-webkit-text-fill-color: #303133;
}

::v-deep .w-e-text-placeholder {
	top: 0 !important;
	font-style: normal;
}

::v-deep .error {
	.w-e-text-placeholder {
		color: #f56c6c;
	}
}

::v-deep .w-e-text-container {
	height: 100%;

	.w-e-scroll {
		height: 100%;
	}
}

::v-deep .w-e-text-container [data-slate-editor] p {
	margin: 0;
	text-align: left;
	font-size: 32px;
}

.showSeries-box {
	width: 90vw;
	box-sizing: border-box;

	.show-title {
		color: #333;
		font-size: 28px;
		width: 100%;
		padding: 20px 0;
		text-align: center;
	}

	.show-list {
		width: 100%;
		box-sizing: border-box;
		padding-left: 20px;
		display: flex;
		flex-wrap: wrap;
		max-height: 300px;
		overflow: auto;

		.list {
			padding: 0 20px;
			height: 62px;
			line-height: 62px;
			margin-right: 20px;
			margin-bottom: 20px;
			border-radius: 31px;
			border: 1px solid #3f996c;
			color: #3f996c;
			font-size: 28px;
		}
	}
}

.choose.all {
	color: #666;
}

.choose.long {
	width: 260px !important;

	.van-cell {
		width: 260px;
	}
}

.mart-box {
	border-top: 1px solid #dbdbdb;
	padding: 20px 0;

	.mart-title {
		padding-left: 25px;
		color: #909399;
		font-size: 28px;
		position: relative;
		height: 30px;
		line-height: 30px;
		text-align: left;
		margin-bottom: 20px;

		span {
			color: #3f996c;
			font-weight: bold;
			margin-left: 5px;
		}

		&::after {
			content: "";
			width: 10px;
			height: 10px;
			border-radius: 10px;
			left: 0;
			top: 10px;
			position: absolute;
			background: #3f996c;
		}
	}

	.country-box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		height: 64px;
		align-items: center;
		margin-bottom: 20px;

		.name {
			font-size: 32px;
			color: #606266;
		}

		.van-cell {
			width: 140px;
			height: 64px;
			line-height: 64px;
			border: 1px solid #dbdbdb;
			box-sizing: border-box;
			padding: 0 10px;

			::v-deep &.van-field--disabled {
				border: none;

				input {
					color: #303133 !important;
					-webkit-text-fill-color: #303133;
					text-align: right;
				}
			}
		}
	}
}

.add-box {
	overflow: hidden;
	margin-top: 30px;

	.addColor {
		width: 170px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #fff;
		font-size: 28px;
		border-radius: 12px;
		float: right;
		background: #3f996c;
	}
}

.seriesError {
	color: #f56c6c;
	font-size: 22px;
	width: 100%;
	height: 24px;
	line-height: 24px;
	text-align: left;
	padding-left: 20px;
	box-sizing: border-box;
}

::v-deep .van-checkbox__icon--round .van-icon {
	border-radius: 0 !important;
	width: 30px;
	height: 30px;
	line-height: 30px;
	font-size: 20px;
}

::v-deep .van-checkbox__icon--checked .van-icon {
	background: #3f996c;
	border-color: #3f996c;
}

::v-deep .van-checkbox__icon {
	width: 30px;
	height: 30px;
}

.series-box {
	display: flex;
	width: calc(100vw - 30px);

	.series-list {
		width: 100%;

		&:nth-child(2) {
			background: #f5f5f5;
		}

		&:nth-child(3) {
			background: #f0f0f0;
		}

		.title {
			height: 70px;
			line-height: 70px;
		}

		.list-box {
			height: 45vh;
			overflow: auto;

			.series-cell {
				padding: 15px 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;

				&.active {
					background: #f0f0f0;
				}
			}
		}
	}
}

.van-cell {
	padding: 0;
}

.padding-box {
	width: 100%;
	position: relative;
	overflow: hidden;
	background: #f1f1f1;
	box-sizing: border-box;
	padding: 30px 30px 200px;
	min-height: calc(100vh - 88px);

	.topinfo {
		width: 100%;
		background: #fff;
		box-sizing: border-box;
		padding: 66px 20px 10px;
		text-align: left;
		border-radius: 22px;
		position: relative;
		word-break: break-all;
		word-wrap: break-word;

		>div {
			color: #303133;
			font-size: 32px;
			line-height: 52px;
			display: flex;

			>div {
				width: 150px;
				flex-shrink: 0;
				text-align: right;
				margin-right: 10px;
				word-break: break-all;
				word-wrap: break-word;
			}

			&.active {
				text-align: right;
				line-height: 52px;
			}
		}

		.time {
			position: absolute;
			right: 20px;
			top: 20px;
			color: #909399;
			font-size: 26px;
			text-align: right;

			span {
				color: #3f996c;
			}
		}
	}

	.change-box {
		width: 100%;
		background: #fff;
		box-sizing: border-box;
		padding: 0 20px;
		border-radius: 22px;
		position: relative;
		margin-top: 30px;

		.del-right {
			overflow: hidden;

			.delet {
				width: 100px;
				height: 48px;
				line-height: 48px;
				font-size: 30px;
				border-radius: 6px;
				text-align: center;
				margin: 20px 0 10px;
				float: right;
				border: 1px solid #dbdbdb;
			}
		}

		&.textarea-box {
			padding: 20px 20px;
			text-align: left;
			font-size: 32px;

			.box-height {
				min-height: 200px;
			}

			&.error {
				border: 1px solid #f56c6c;
			}
		}

		.cell {
			.name {
				flex-shrink: 0;
			}
		}
	}
}

.publisher-list {
	overflow-y: scroll;

	.van-picker-column {
		overflow: auto;
		padding-top: 40px;
	}

	.select {
		.text {
			color: #3F996C !important;
		}

		.van-icon {
			color: #3F996C !important;
		}
	}

	.column-item {
		margin-bottom: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 40px;

		.text {
			font-family: Microsoft YaHei;
			font-weight: 400;
			font-size: 32px;
			color: #999999;
		}

		.van-icon {
			color: #fff;
		}
	}
}
</style>
